import { Button } from '@/components/atoms/Button';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InsightButton = styled(Button)(({ theme }) => ({
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
    border: 'none',
  },
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: 1,
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('xmd')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));

export const StyledFlex = styled(Box, {
  shouldForwardProp: (prop) =>
    !['justify', 'align', 'gap', 'fullWidth'].includes(prop as string),
})(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('xmd')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(2),
  },
}));
